import { render } from "./BlockGroup.vue?vue&type=template&id=430c41cc&scoped=true"
import script from "./BlockGroup.vue?vue&type=script&lang=js"
export * from "./BlockGroup.vue?vue&type=script&lang=js"

import "./BlockGroup.vue?vue&type=style&index=0&id=430c41cc&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-430c41cc"]])

export default __exports__